import {IconButton, InputBase, TableCell, TableRow, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Delete02Icon} from "@hugeicons/core-free-icons";

const iconButtonSx = {borderRadius: "50% !important", color: "#8A8AA0", "&:hover": {bgcolor: "rgba(220, 38, 38, 0.08)", color: "#DC2626"}};

export const PhoneNumberRowNew = ({row, index, duplicate, empty, onChange, onDelete}) => {
  return (
    <TableRow sx={{bgcolor: duplicate ? "rgba(217, 161, 58, 0.08)" : "transparent"}}>
      <TableCell sx={{fontSize: 12, color: "#8A8AA0", borderBottom: "1px solid #F2F2F7"}}>{index}</TableCell>
      <TableCell sx={{borderBottom: "1px solid #F2F2F7"}}>
        <InputBase
          fullWidth
          value={row.value}
          onChange={(e) => onChange(row.id, e.target.value)}
          inputProps={{"aria-label": "Phone number"}}
          sx={{fontSize: 13, color: empty ? "#DC2626" : "#23264D"}}
        />
        {(duplicate || empty) && (
          <Typography sx={{fontSize: 11, color: duplicate ? "#A86A0C" : "#DC2626", mt: 0.25}}>
            {duplicate ? "Duplicate number" : "Empty number"}
          </Typography>
        )}
      </TableCell>
      <TableCell padding="checkbox" sx={{borderBottom: "1px solid #F2F2F7"}}>
        <Tooltip title="Remove">
          <IconButton size="small" onClick={() => onDelete(row.id)} sx={iconButtonSx}>
            <HugeiconsIcon icon={Delete02Icon} size={15}/>
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}
